// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c-ki","largestCol":"styles_largestCol__qyldq","smallestCol":"styles_smallestCol__2C0Fm"};